import React, { useState } from 'react';
import * as fileService from "../services/fileService";
import Swal from 'sweetalert2'

export default function UploadShedule() {

    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState('');

    const handleFileChange = (event) => {
       
        const file = event.target.files[0];
      
        if (file && file.name.endsWith('.pdf')) {
            setFile(file);
        } else {
            // Alert the user if the file is not a PDF
            Swal.fire({ title: "Внимание", text: 'Може да прилагате само pdf файлове!', icon: "error" });
            event.target.value = '';
        }
    };

    const handleFileUpload = async (e) => {
        e.preventDefault();

        if (!file) { Swal.fire({ title: "Внимание", text: 'Моля изберете файл!', icon: "error" }); return; }

        try {

            let formData = new FormData();
            formData.append('PdfFile', file);

            const res = await fileService.create(formData);
            setFile(null);
            document.getElementById('idfile').value = '';

            Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
        } catch (error) {
            Swal.fire({ title: "Грешка при обновяване!", text: error.message, icon: "error" });
        }
    }


    return (
        <div className="col-12">
            <div className="overflow-auto card recent-sales p-5 p-4-mob">
                <h5 className="card-title"><span>Подмяна на график (задължително pdf file)</span></h5>

                <form >
                    <input type="file" id="idfile" onChange={handleFileChange} />
                    <button className="btn btn-primary mt-2 mb-2 w-16 w-35-mob" onClick={handleFileUpload}>Подмяна</button>
                    {uploadStatus && <p>{uploadStatus}</p>}
                </form>

            </div>
        </div>

    )
}